import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import IconButton from "../../elements/IconButton";

const Base = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${select.fontSize(0)};
  color: ${select.color(["grey", 2])};
  transition: 0.2s;
`;

const Center = styled.div`
  font-family: ${select.font("Lato")};
  text-transform: uppercase;
  color: ${select.color(["grey", 6])};
  font-size: inherit;
`;

type Props = {
  month: number;
  year: number;
  className?: string;
  style?: React.CSSProperties;
  onPreviousMonth?: () => void;
  onNextMonth?: () => void;
  monthNames: string[];
};

class MonthPicker extends React.Component<Props> {
  render() {
    const {
      month,
      year,
      className,
      style,
      onPreviousMonth,
      onNextMonth,
      monthNames
    } = this.props;

    return (
      <Base className={className} style={style}>
        <IconButton name="left" onClick={onPreviousMonth} />
        <Center>
          {monthNames[month]} {year}
        </Center>
        <IconButton name="right" onClick={onNextMonth} />
      </Base>
    );
  }
}

export default MonthPicker;
